import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ProductSoldModel } from 'src/app/models/product-sold.model';
import { ProductsService } from 'src/app/services/products/products.service';
import { faX} from '@fortawesome/free-solid-svg-icons'; // O far para regular
@Component({
  selector: 'app-product-sold',
  templateUrl: './product-sold.component.html',
  styleUrls: ['./product-sold.component.scss']
})
export class ProductSoldComponent {
  @Input() data: any;
  @Input() title = '';
  @Input() msg = '';
  @Input() btn_msg_yes = '';
  @Input() btn_msg_no = '';
  @Input() callback_yes = () => {};
  @Input() callback_no = () => {};
  applicationFormGroup: RxFormGroup;
  isLogin = false;
  faClose= faX;
  typePassword: boolean = true; // Or initialize as needed
  titleCard = 'Producto agotado'
  constructor(public activeModal: NgbActiveModal,private fb: RxFormBuilder,
    private router: Router,
    private productsService: ProductsService
  ) {
   
  }

  async ngOnInit(): Promise<void> {
    await this.initForm();
    if(this.data && this.data.id_service){
      this.titleCard = 'Contactar proveedor'
    }
  }
  async initForm(): Promise<void> {
    return new Promise((resolve) => {        
      const generate = new ProductSoldModel();
      this.applicationFormGroup = (this.fb.formGroup(generate) as RxFormGroup);
      
      resolve();
    });
}
postApplication(){
  if (this.applicationFormGroup.valid) {
    this.isLogin = true;
    let data = {
      form: this.applicationFormGroup.value,
      data_product: this.data
    }
    this.productsService.sendProductSold(data).subscribe({
      next: async (response) => {
       this.onYes();
      },
      error: (error) => {
        console.error('Login failed', error);
        this.isLogin = false;
      }
    });
  } else {
    this.applicationFormGroup.markAllAsTouched();
  }
}
showPassword() {
  this.typePassword = !this.typePassword;
}
  onYes() {
    this.activeModal.close('login');
    this.callback_yes();
  }

  onNo() {
    this.activeModal.close('close');
    this.callback_no();
  }
}

